import type { DirectiveBinding } from 'vue'

type ClickOutsideHandler = (event: Event) => void

const handlers = new WeakMap<HTMLElement, ClickOutsideHandler>()

const createHandler = (el: HTMLElement, callback: ClickOutsideHandler): ClickOutsideHandler => {
  return (event: Event) => {
    const target = event.target

    if (target instanceof Node && (target === el || el.contains(target))) {
      return
    }

    callback(event)
  }
}

export default {
  beforeMount(el: HTMLElement, binding: DirectiveBinding<ClickOutsideHandler>) {
    if (typeof binding.value !== 'function') {
      return
    }

    const handler = createHandler(el, binding.value)
    handlers.set(el, handler)
    document.addEventListener('click', handler)
  },
  unmounted(el: HTMLElement) {
    const handler = handlers.get(el)

    if (!handler) {
      return
    }

    document.removeEventListener('click', handler)
    handlers.delete(el)
  }
}
